var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',_vm._g(_vm._b({attrs:{"value":_vm.value,"eager":_vm.eager,"transition":_vm.transition,"reverse-transition":_vm.reverseTransition,"disabled":_vm.disabled}},'v-tab-item',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }